import React, { useState } from 'react';
import axios from 'axios';

const URL = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/`;

const UpdateRecordsForm = () => {
  const [recordId, setRecordId] = useState('');
  const [file, setFile] = useState(null);
  const [updatedCount, setUpdatedCount] = useState(0);
  const [failedCount, setFailedCount] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  // פונקציה לטיפול בשינוי שדה ה-select
  const handleRecordChange = (e) => {
    setRecordId(e.target.value);
  };

  // פונקציה לטיפול בבחירת קובץ
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // פונקציה לשליחת הנתונים לשרת
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!recordId || !file) {
      alert('יש לבחור רשומה ולהעלות קובץ.');
      return;
    }
  
    const formData = new FormData();
    formData.append('recordId', recordId);
    formData.append('file', file);
  
    try {
      console.log('Sending request with recordId:', recordId);
      const response = await axios.post(URL + 'api/uploadFiles/updateRecords', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      console.log('Response from server:', response.data);
  
      if (response.data.success) {
        const { updatedRecords, failedRecords } = response.data;

        // עדכון הנתונים להצגה
        setUpdatedCount(updatedRecords.length);
        setFailedCount(failedRecords.length);
        setTotalRecords(updatedRecords.length + failedRecords.length);

        alert('הרשומות עודכנו בהצלחה!');
      } else {
        const { updatedRecords, failedRecords } = response.data;

        // עדכון הנתונים להצגה
        setUpdatedCount(updatedRecords.length);
        setFailedCount(failedRecords.length);
        setTotalRecords(updatedRecords.length + failedRecords.length);

        alert(
          `חלק מהרשומות לא עודכנו:\nעודכנו בהצלחה: ${updatedRecords.join(', ')}\nנכשלו: ${failedRecords.join(', ')}`
        );
      }
    } catch (error) {
      console.error('שגיאה בשליחת הנתונים:', error.response?.data || error.message);
      alert('שגיאה בשליחת הנתונים לשרת.');
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="recordId">רשומה לעדכון:</label>
          <select id="recordId" value={recordId} onChange={handleRecordChange} required>
            <option value="">בחר רשומה</option>
            <option value="cemeteries">Cemeteries</option>
            <option value="blocks">Blocks</option>
            <option value="plots">Plots</option>
            <option value="rows">Rows</option>
            <option value="areaGraves">Area Graves</option>
            <option value="graves">Graves</option>
            <option value="customers">Customers</option>
            <option value="purchases">Purchases</option>
            <option value="burials">Burials</option>
            <option value="countries">Countries</option>
            <option value="cities">Cities</option>
          </select>
        </div>

        <div>
          <label htmlFor="file">העלה קובץ אקסל לעדכון:</label>
          <input type="file" id="file" accept=".xlsx, .xls" onChange={handleFileChange} required />
        </div>

        <button type="submit">עדכן</button>
      </form>

      {/* הצגת סטטיסטיקות */}
      {totalRecords > 0 && (
        <div style={{ marginTop: '20px' }}>
          <p>סה"כ רשומות: {totalRecords}</p>
          <p>רשומות שעודכנו: {updatedCount}</p>
          <p>רשומות שנכשלו: {failedCount}</p>
        </div>
      )}
    </div>
  );
};

export default UpdateRecordsForm;
